import utils from "../utils";

function init() {
	var imgs = document.querySelectorAll("[data-srcset]");
		
	//https://caniuse.com/intersectionobserver

	function initAnimationThumb(elem) {
		let sources = elem.querySelectorAll('source');

		utils.forEach(sources, function(source_key, source){

			var srcset = source.getAttribute("data-srcset");
			source.setAttribute("srcset", srcset);
			source.removeAttribute("data-srcset");

		});

		var parent = elem.parentElement,
			thumb = parent.querySelector("img.thumb"),
			img = elem.querySelector("img");

		utils.isImageLoaded(img, function () {
			parent.classList.add("lazy");

			img.addEventListener("transitionend", function () {
				if (thumb) {
					thumb.style.display = "none";
				}
			});
			img.addEventListener("transitioncancel", function () {
				if (thumb) {
					thumb.style.display = "none";
				}
			});
		});
	}

	function startObserverLazy() {
		let lazyImageObserver = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						var lazyImage = entry.target;
						initAnimationThumb(lazyImage);
						lazyImageObserver.unobserve(lazyImage);
					}
				});
			},
			{
				rootMargin: "20% 0px 20% 0px",
				threshold: 0.5,
			}
		);
		utils.forEach(imgs, function (index, elem) {
			elem = elem.parentElement;
			lazyImageObserver.observe(elem);
		});
	}

	if (imgs.length > 0) {
		startObserverLazy();
	}
}

export default {init};
